module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASklEQVQ4y2P4jwQ+MAww7wADDNgPCh6QYP4/GHj8wPA5wP+HYTDwQC4DgcHAg7hscPCAkYXszoHmMdj/h8fYwPIGOhcjeIOnrAMAk5AA0E768SkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTZUMTc6MTg6MTArMDk6MDCdK/HjAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00002_100x100.png
// module id = tvG+
// module chunks = 0